import { ReactNode } from 'react';
import { ChartReportDto, ServiceProviderDetailsDto } from 'src/generated/services/TFinancialApi';

export enum LandingSectionName {
  ALL = 'ALL',
  AUDIT = 'AUDIT',
  ANALYTIC = 'ANALYTIC',
  PERFORMANCE = 'PERFORMANCE',
  RATECARD = 'RATECARD',
}

export interface ISearchFormValues {
  keyword: string;
}

export interface ILandingSectionProps {
  title: string;
  icon: string;
  linkDetail: string;
  topRight?: ReactNode;
  children: ReactNode;
  isLoading?: boolean;
  onRefresh?: () => Promise<any>;
  skeletonType?: 'cards' | 'list';
  id?: string;
}

export interface LandingPerformanceProps {
  isLoading?: boolean;
  onRefresh?: () => Promise<any>;
}

export interface LandingAnalyticsProps {
  isLoading?: boolean;
  onRefresh?: () => Promise<any>;
}

export interface LandingRateCardProps {
  isLoading?: boolean;
  onRefresh?: () => Promise<any>;
}

export interface ILandingMenuProps {
  selected: string;
  auditTotal: number;
  analyticTotal: number;
  performanceTotal: number;
  ratecardTotal?: number;
  onChangeMenu(name: string): void;
  onRefresh(): void;
  availableSections?: string[];
}

export interface IServiceList {
  AIR: ServiceProviderDetailsDto[];
  ROAD: ServiceProviderDetailsDto[];
  SEA: ServiceProviderDetailsDto[];
  CT: ServiceProviderDetailsDto[];
  COURIER: ServiceProviderDetailsDto[];
}

export interface IAuditProps {
  providers: ServiceProviderDetailsDto[];
  isLoading?: boolean;
  onRefresh?: () => Promise<any>;
}

export interface IAuditProvidersProps {
  providers: ServiceProviderDetailsDto[];
  modality: ServiceProviderDetailsDto['modality'];
  categoryIdGen: (title: string) => string;
  cardIdGen: (title: string) => string;
}

export interface ILandingTopWidgetProps {
  title?: string;
  children?: ReactNode;
  hideNotification?: boolean;
  hideSearchBar?: boolean;
  hideUploadButton?: boolean;
}

export interface RefreshIconProps {
  refreshing?: boolean;
}

export interface IReportCardProps {
  item: ChartReportDto;
  rootPath?: string;
  onDelete?: () => void;
}
